import { useState } from 'react';

import classes from './MobileCountrySelector.module.css';
import CountryInput from '../CountryInput';
import MobilePhoneInput from '../MobilePhoneInput';
import InputError from 'Components/UI_Library/FormElements/InputError';

type Country = {
    /** @example Australia */
    name: string;
    /** @example AU */
    code: string;
    /** @example +61 */
    countryCode: string;
};

type Props = {
    error?: boolean;
    mobileError?: string;
    required?: boolean;
    value?: string;
    getMobileCountry: (country: Country, mobile: string) => void;
    flexed?: boolean;
    placement?: 'vertical' | 'horizontal';
    hideLabels?: boolean;
    optionFullWidth?: boolean;
};

const MobileCountrySelector = (props: Props) => {
    const [country, setCountry] = useState({ name: 'Australia', code: 'AU', countryCode: '+61' });
    const [mobile, setMobile] = useState(props.value ?? '');
    const errors = props.mobileError;
    const selectCountry = (country: Country) => {
        /** update the mobile number as user updates country. Replaces the country code in the mobile number (if it exists) */
        const updateMobile = (country: Country) => {
            if (mobile?.startsWith(country?.countryCode)) {
                return mobile.replace(country?.countryCode, country.countryCode);
            }
            return mobile;
        };
        setCountry(country);
        setMobile(updateMobile(country));
        props.getMobileCountry(country, mobile);
    };

    const handleChangeMobile = (mobile: string) => {
        setMobile(mobile);
        props.getMobileCountry(country, mobile);
    };

    return (
        <>
            {props.flexed ? (
                <div
                    className={`${classes.container} ${
                        props.placement === 'horizontal' ? classes.containerHorizontal : ''
                    }`}
                >
                    <div
                        className={`form-group ${props.placement === 'horizontal' ? classes.formGroupHorizontal : ''}`}
                    >
                        {!props.hideLabels && (
                            <label>Country{props.required && <span className={classes.required}>*</span>}</label>
                        )}
                        <CountryInput
                            displayCode
                            selected={country}
                            select={selectCountry}
                            optionFullWidth={props.optionFullWidth}
                        />
                    </div>
                    <div
                        className={`form-group ${props.error ? classes.fieldError : ''} ${
                            props.placement === 'horizontal' ? classes.formGroupHorizontal : ''
                        }`}
                    >
                        {!props.hideLabels && (
                            <label>Mobile number{props.required && <span className={classes.required}>*</span>}</label>
                        )}
                        <MobilePhoneInput
                            placeholder={`${country.countryCode || '+'}000000000`}
                            countryCode={country.countryCode}
                            value={mobile}
                            onChange={(e: { target: { value: string } }) => handleChangeMobile(e.target.value)}
                        />
                        <InputError error={errors} />
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default MobileCountrySelector;
